// extracted by mini-css-extract-plugin
export default {"pwdChange":"PasswordChange_pwdChange__tPW+E","formFooter":"PasswordChange_formFooter__GvXRM"};